import React from 'react';

const PPT = ({ locales, slug, webLink }) => {
  const link = `${window.location.origin}/portfolio/${slug}/${webLink}.ppt`;

  return (
    <div className="pdf">
      <div className="title">{locales.pptFile.description}</div>
      <div className="bottom">
        <div className="text-wrapper">
          <div className="text">{link}</div>
        </div>
        <a
          className="bmc-button bmc-button--primary"
          href={link}
          target="_blank"
        >
          {locales.download}
        </a>
      </div>
    </div>
  );
};

export default PPT;
